import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import get from 'lodash/get';
import sampleSize from 'lodash/sampleSize';
import Card from '../card/card';
import Slug from '../slug/slug';
// import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';

function formatAMPM(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return strTime;
}

class RelatedParselyPosts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchedArticles: []
    };
  }

  componentDidMount() {
    const { config, post } = this.props;
    const uuid = get(window, 'PARSELY.config.uuid');
    const site = get(config, 'site');
    const pubDateStart = '35w';
    const pubDateEnd = '1m';

    const parselyURL = `https://api.parsely.com/v2/related?apikey=${site}.com&url=${
      post.link
    }&uuid=${uuid}&pub_date_start=${pubDateStart}&pub_date_end=${pubDateEnd}`;

    axios
      .get(parselyURL)
      .then(response => {
        this.setState({
          fetchedArticles: sampleSize(response.data.data, 3)
        });
      })
      .catch(error => {
        console.log(error) // eslint-disable-line
      });
  }

  render() {
    const { config } = this.props;

    return (
      <div className="related-posts">
        <Slug slugName="Related Stories" className="column" />
        {this.state.fetchedArticles.map(article => {
          const originDate = new Date(article.pub_date);
          return (
            <Card
              config={config}
              type="small"
              metadata={{
                title: article.title,
                link: article.url,
                featured_image: {
                  source: article.image_url
                },
                dateFormatted: `${`0${originDate.getMonth() + 1}`
                  .slice(-2)
                  .toString()}.${originDate.getDay().toString()}.${originDate
                  .getFullYear()
                  .toString()
                  .substr(-2)}`,
                timePublished: formatAMPM(originDate)
              }}
              key={article.id}
            />
          );
        })}
      </div>
    );
  }
}

RelatedParselyPosts.propTypes = {
  config: PropTypes.shape({}).isRequired,
  post: PropTypes.shape({}).isRequired
};

export default RelatedParselyPosts;
